<script>
    import {
        CardLayout,
        CustomTooltip,
        Loader,
        NotificationModal,
        UnsetPatientBadDebtorByMedicareModal,
    } from "../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import {
        encodeSearchParams,
        getBoolean,
        getFormatBirthDate,
        getGenderType,
        getOpvStatusDVA,
        getOpvStatusHealthFund,
        getOpvStatusMedicare,
        getText,
        getTime,
        getTitle,
        getValidBillingData,
        goToURL,
        isObjectEmpty,
        isWithinBusinessHours,
        runWithCommunicationsCheck,
        scrollIntoView,
        showError,
        showException,
        splitCamelCase,
    } from "../../../Utils/utilFunctions.svelte";

    import {
        getFormatOpvFailLogs,
        isSufficientTimeToCreateEstimatesOrInvoices,
        loadActivityAndEncounterLogs,
        syncInsuranceDetailsOfLatestBillingData,
    } from "../helpers/encounterHelper.svelte";

    import { isSufficientTimeToNotifyPatient } from "../helpers/encounterHelper.svelte";

    import PatientInsuranceDetails from "./PatientInsuranceDetails.svelte";

    import { EncounterSidePanelProps, user } from "../../../stores";

    import {
        BillingStatus,
        DirectEncounterStatus,
        DirectInsuranceType,
    } from "../../../Utils/utilEnums.svelte";

    import { defaultErrorMsgPrompt } from "../../../Utils/utilConstants.svelte";
    import OpvOnDiffFund from "./OPVOnDiffFund.svelte";
    import { isEnvApp, isEnvNewOrApp } from "../../../Utils/utilRoute.svelte";

    export let patientDetails = {};
    export let billingData = [];
    export let encounterId, patientEncounter;
    export let reloadPatientDetails = () => {};
    export let reloadPatientEncounter = () => {};
    export let updatePatientEncounter = () => {};
    export let loadEncounterStatusOfPatient = () => {};
    export let logsLoaded = false;
    export let eclipseLogsData = [];
    export let isFromCalendarList = false;

    $: displayFullName = _getPatientFullName(patientDetails);

    $: isUserAdmin = $user.role == 100;

    $: if (patientDetails?.id) triggerLoadEncounterStatusOfPatient();

    $: bottomLinks = [
        {
            displayName: `Total encounters for the patient: ${encounterStatusOfPatient.total}`,
            isDisabled: !encounterStatusOfPatient.total,
            isHidden: isLoadingEncounterStatusOfPatient,
            isLoading: isLoadingEncounterStatusOfPatient,
            clickFunc: () => handleGoToEncounterPage("total"),
        },
        {
            displayName: `Still open: ${encounterStatusOfPatient.stillOpen}`,
            isDisabled: !encounterStatusOfPatient.stillOpen,
            isHidden: isLoadingEncounterStatusOfPatient,
            isLoading: isLoadingEncounterStatusOfPatient,
            clickFunc: () => handleGoToEncounterPage("stillOpen"),
        },
        {
            displayName: `On hold: ${encounterStatusOfPatient.onHold}`,
            isDisabled: !encounterStatusOfPatient.onHold,
            isHidden: isLoadingEncounterStatusOfPatient,
            isLoading: isLoadingEncounterStatusOfPatient,
            clickFunc: () => handleGoToEncounterPage("onHold"),
        },
        {
            displayName: `Archived: ${encounterStatusOfPatient.archived}`,
            isDisabled: !encounterStatusOfPatient.archived,
            isHidden: isLoadingEncounterStatusOfPatient,
            isLoading: isLoadingEncounterStatusOfPatient,
            clickFunc: () => handleGoToEncounterPage("archived"),
        },
        {
            displayName: `Fee estimates: ${encounterStatusOfPatient.totalFeeEstimates}`,
            isDisabled: !encounterStatusOfPatient.totalFeeEstimates,
            isHidden: isLoadingEncounterStatusOfPatient,
            isLoading: isLoadingEncounterStatusOfPatient,
            clickFunc: () => handleGoToEncounterPage("total", true),
        },
    ];

    let isCheckingOPV = false,
        isSuggestionModalOpen = false,
        isApplyingSuggestion = false;

    let isSendNotificationModalOpen = false,
        isSendingNotificationToPatient = false,
        isNotificationFinishModalOpen = false;

    let suggestedPatientInfo = {};

    let isUpdatingEncounterOpvManuallyApprove = false;

    let isCancelUpdateRequestModalOpen = false,
        isCheckOpvOnDiffFundModalOpen = false,
        isCancelNotificationModalOpen = false;

    let updatePatientBadDebtorByMedicareModalOpen = false,
        isUpdatingPatientBadDebtorByMedicare = false;

    let isLoadingEncounterStatusOfPatient = false,
        encounterStatusOfPatient = {};

    let isLoadingLogs = false,
        needRefreshLogs = true,
        latestEclipseLog = {};

    let isOpvResultModalOpen = false,
        opvVerificationSuccess = false,
        opvResponseWithErrorMsg = false,
        opvResultMsg = "";

    const btnOptions = [
        {
            iconName: "notifyPatientIcon",
            isHidden: (patientEncounter.estimates && patientEncounter.estimates.some((e) => e.status != 9)) || (patientEncounter.invoices && patientEncounter.invoices.some((e) => e.status != 9)),
            iFont: "fa-regular fa-bell",
            iconFunction: () => _openSendNotificationModal(),
            btnText: "Notify patient to update details",
        },
    ];

    $: if (
        patientEncounter?.requestedUpdateDetailsDate &&
        !isSufficientTimeToCreateEstimatesOrInvoices(patientEncounter)
    ) {
        btnOptions[0] = {
            iconName: "cancelNotifyPatientIcon",
            isHidden: (patientEncounter.estimates && patientEncounter.estimates.some((e) => e.status != 9)) || (patientEncounter.invoices && patientEncounter.invoices.some((e) => e.status != 9)),
            iFont: "fa-regular fa-bell-slash",
            iconFunction: () => (isCancelUpdateRequestModalOpen = true),
            btnText: `Cancel request for patient to update details (sent at ${getTime(patientEncounter.requestedUpdateDetailsDate)})`,
        };
    } else {
        btnOptions[0] = {
            iconName: "notifyPatientIcon",
            isHidden: (patientEncounter.estimates && patientEncounter.estimates.some((e) => e.status != 9)) || (patientEncounter.invoices && patientEncounter.invoices.some((e) => e.status != 9)),
            iFont: "fa-regular fa-bell",
            iconFunction: () => _openSendNotificationModal(),
            btnText: "Notify patient to update details",
        };
    }

    let updatePatientBadDebtorByMedicare = async () => {
        isUpdatingPatientBadDebtorByMedicare = true;

        await apiMethods.putMethod
            .updatePatient({
                ...patientDetails,
                badDebtorByMedicare: false,
            })
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to unset patient Bad Debtor recognised by Medicare Number, please refresh the page and try again and contact support if the issue persists.",
                    );
                else {
                    _closeConfirmBadDebtorByMedicareModal();
                    reloadPatientDetails();
                }
            });

        isUpdatingPatientBadDebtorByMedicare = false;
    };

    const triggerLoadEncounterStatusOfPatient = async () => {
        if (isLoadingEncounterStatusOfPatient) return;

        isLoadingEncounterStatusOfPatient = true;

        const res = await loadEncounterStatusOfPatient();

        if (res.error) showError(res.error);
        else encounterStatusOfPatient = { ...res };

        isLoadingEncounterStatusOfPatient = false;
    };

    const runOpvCheck = () => {
        closeSuggestionModal();

        isCheckingOPV = true;

        if (patientDetails.patientEncounterId) {
            apiMethods.postMethod
                .checkOPV({
                    patientEncounterId: patientDetails.patientEncounterId,
                })
                .then((res) => {
                    // if (res.error) {
                    //     isCheckingOPV = false;
                    //     isOpvResultModalOpen = true;
                    //     opvResultMsg = res.error;
                    // } else {
                    //     _handleOPVSuggestions(res);
                    //     needRefreshLogs = true;
                    //     loadLogs();
                    // }

                    isOpvResultModalOpen = true;

                    if (!res || res.error) {
                        opvVerificationSuccess = false;
                        opvResponseWithErrorMsg = !!res.error;
                        opvResultMsg = res.error
                            ? res.error
                            : defaultErrorMsgPrompt;
                    } else {
                        _handleOPVSuggestions(res);
                        needRefreshLogs = true;
                        loadLogs();

                        // reload calendar info after close side panel
                        if (isFromCalendarList)
                            $EncounterSidePanelProps.shouldTriggerCloseFunction = true;
                    }
                });
        } else {
            isCheckingOPV = false;
            showError(
                "Missing patient encounter id, please contact support...",
            );
        }
    };

    const updateEncounterOpvManuallyApprove = async () => {
        isUpdatingEncounterOpvManuallyApprove = true;

        await apiMethods.putMethod
            .updatePatientEncounter({
                ...patientEncounter,
                opvManuallyApproved: !patientEncounter.opvManuallyApproved,
            }, false, "OPV manually approved")
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to change OPV Manually Approve value, please refresh the page and try again and contact support if the issue persists.",
                    );
                else reloadPatientDetails();
            })
            .catch((err) => showError(err));

        isUpdatingEncounterOpvManuallyApprove = false;
    };

    const applySuggestion = async () => {
        isApplyingSuggestion = true;

        if (billingData.length) {
            // update last billing data;
            const lastBillingData = getValidBillingData(billingData);

            if (!lastBillingData || !lastBillingData.id) {
                // no valid billing data;
                isSuggestionModalOpen = false;
                showError("Failed to find valid billing data");
            } else {
                // found valid billing data
                if (suggestedPatientInfo.suggestedMedicareNum)
                    lastBillingData.patientMedicareNo =
                        suggestedPatientInfo.suggestedMedicareNum;
                if (suggestedPatientInfo.suggestedMedicareReference)
                    lastBillingData.patientMedicareRefNo =
                        suggestedPatientInfo.suggestedMedicareReference;
                if (suggestedPatientInfo.suggestedInsuranceId)
                    lastBillingData.patientInsuranceId =
                        suggestedPatientInfo.suggestedInsuranceId;

                if (suggestedPatientInfo.suggestedName)
                    patientDetails.firstName =
                        suggestedPatientInfo.suggestedName;
                if (suggestedPatientInfo.suggestedLastName)
                    patientDetails.lastName =
                        suggestedPatientInfo.suggestedLastName;
                if (suggestedPatientInfo.suggestedBirthdate)
                    patientDetails.birthDate =
                        suggestedPatientInfo.suggestedBirthdate;

                if (
                    suggestedPatientInfo.suggestedName ||
                    suggestedPatientInfo.suggestedLastName ||
                    suggestedPatientInfo.suggestedBirthdate
                )
                    await apiMethods.putMethod.updatePatient(patientDetails);

                billingData.map((bd) => {
                    if (bd.id == lastBillingData.id)
                        bd = { ...lastBillingData };
                });

                await updatePatientEncounter(billingData);
            }
        } else {
            // update patientDetails directly
            if (suggestedPatientInfo.suggestedMedicareNum)
                patientDetails.medicareNo =
                    suggestedPatientInfo.suggestedMedicareNum;
            if (suggestedPatientInfo.suggestedMedicareReference)
                patientDetails.medicareRefNo =
                    suggestedPatientInfo.suggestedMedicareReference;
            if (suggestedPatientInfo.suggestedInsuranceId)
                patientDetails.insuranceId =
                    suggestedPatientInfo.suggestedInsuranceId;
            if (suggestedPatientInfo.suggestedName)
                patientDetails.firstName = suggestedPatientInfo.suggestedName;
            if (suggestedPatientInfo.suggestedLastName)
                patientDetails.lastName =
                    suggestedPatientInfo.suggestedLastName;
            if (suggestedPatientInfo.suggestedBirthdate)
                patientDetails.birthDate =
                    suggestedPatientInfo.suggestedBirthdate;

            await apiMethods.putMethod.updatePatient(patientDetails);

            await updatePatientEncounter();
        }

        closeSuggestionModal();

        isApplyingSuggestion = false;
    };

    const sendNotificationToPatient = async (sendNow = false) => {
        runWithCommunicationsCheck(patientEncounter, async () => {
            _closeSendNotificationModal();

            isSendingNotificationToPatient = true;

            btnOptions[0].isLoading = true;

            await apiMethods.postMethod
                .sendNotifyPatient(encounterId, sendNow)
                .then((res) => {
                    if (getBoolean(res) == "Yes") {
                        _openAfterSendNotificationModal();
                        reloadPatientDetails();
                    } else
                        showError(
                            "Failed to send notification to patient, please refresh the page and try again and contact support if the issue persists.",
                        );
                });

            btnOptions[0].isLoading = false;

            isSendingNotificationToPatient = false;
        });
    };

    const closeSuggestionModal = () => {
        isCheckingOPV = false;
        isSuggestionModalOpen = false;
        isApplyingSuggestion = false;

        suggestedPatientInfo = {};
    };

    const handleGoToEncounterPage = (type = "", goToFeeEstimates = false) => {
        if (!type) return;

        if (encounterStatusOfPatient[type] == 0) return;

        let searchParams = `start=0&limit=25&patientId=${patientDetails.id}`;

        switch (type) {
            case "total":
                const allEncounterBillingStatus = [];
                BillingStatus.map((s) => allEncounterBillingStatus.push(s.id));
                searchParams += `&billingStatus=${allEncounterBillingStatus.join()}`;
                searchParams += `&status=${Object.values(DirectEncounterStatus).join(",")}`;
                break;
            case "stillOpen":
                searchParams += `&billingStatus=0,1,2,3,4`;
                break;
            case "archived":
                searchParams += `&status=9`;
                break;
            case "onHold":
                searchParams += `&billingStatus=0,1,2,3,4&status=1`;
                break;

            default:
                break;
        }
        if(goToFeeEstimates){
            window.open(
                `/#/PatientQuote/${encodeSearchParams(searchParams)}`,
                "_self",
            );
        } else {
            window.open(
                `/#/PatientEncounter/${encodeSearchParams(searchParams)}`,
                "_blank",
            );
        }
        
    };

    const loadLogs = async () => {
        if (eclipseLogsData.length && !needRefreshLogs) {
            latestEclipseLog = getFormatOpvFailLogs(eclipseLogsData);
            return;
        }

        isLoadingLogs = true;

        const res = await loadActivityAndEncounterLogs(patientEncounter.id);

        if (res.error) showError(res.error);
        else {
            eclipseLogsData = [...res.eclipseLogs];

            latestEclipseLog = getFormatOpvFailLogs(eclipseLogsData);
        }

        isLoadingLogs = false;
        needRefreshLogs = false;
    };

    // HELPER FUNCTIONS
    const _getPatientFullName = (patientInfo) => {
        const { title, firstName, middleName, lastName } = patientInfo;

        return `${getTitle(title)} ${firstName} ${middleName} ${lastName}`;
    };

    const _getPatientAddress = () => {
        const { address, city, state, postCode } = patientDetails;

        const res = [];

        if (address) res.push(address);
        if (city) res.push(city);
        if (state) res.push(state);
        if (postCode) res.push(postCode);

        return res.join(", ");
    };

    const _redirectToPatient = () => {
        goToURL(`/Patient/view/${patientDetails.id}`, isFromCalendarList);
    };

    const _handleOPVSuggestions = (response) => {
        isCheckingOPV = false;

        const {
            suggestedMedicareNum,
            suggestedMedicareReference,
            suggestedName,
            suggestedLastName,
            suggestedInsuranceId,
            suggestedBirthdate,
            medicareStatus,
            medicareText,
            healthFundStatus,
            healthFundText,
            veteranStatus,
            veteranText,
        } = response;

        const validSuggestions =
            suggestedMedicareNum ||
            suggestedMedicareReference ||
            suggestedName ||
            suggestedLastName ||
            suggestedInsuranceId ||
            suggestedBirthdate;

        if (!validSuggestions) {
            const encounterInsuranceType = isObjectEmpty(
                getValidBillingData(billingData),
            )
                ? patientDetails.insuranceType
                : getValidBillingData(billingData).insuranceType;

            isOpvResultModalOpen = true;

            if (encounterInsuranceType == DirectInsuranceType.DVA) {
                opvVerificationSuccess = veteranStatus == 1;
                opvResultMsg = veteranText;
            } else if (encounterInsuranceType == DirectInsuranceType.Private) {
                opvVerificationSuccess =
                    medicareStatus == 1 && healthFundStatus == 1;
                if (medicareText && medicareStatus != 1)
                    opvResultMsg = `Medicare: ${medicareText} <br />`;
                if (healthFundText && healthFundStatus != 1)
                    opvResultMsg += `Health Fund: ${healthFundText}`;
            } else {
                opvVerificationSuccess = medicareStatus == 1;
                opvResultMsg = medicareText;
            }

            reloadPatientDetails();
        } else {
            if (suggestedMedicareNum)
                suggestedPatientInfo.suggestedMedicareNum =
                    suggestedMedicareNum;
            if (suggestedMedicareReference)
                suggestedPatientInfo.suggestedMedicareReference =
                    suggestedMedicareReference;
            if (suggestedName)
                suggestedPatientInfo.suggestedName = suggestedName;
            if (suggestedLastName)
                suggestedPatientInfo.suggestedLastName = suggestedLastName;
            if (suggestedInsuranceId)
                suggestedPatientInfo.suggestedInsuranceId =
                    suggestedInsuranceId;
            if (suggestedBirthdate)
                suggestedPatientInfo.suggestedBirthdate = suggestedBirthdate;

            isSuggestionModalOpen = true;
        }

        // reset logsLoaded to false, thus redirect to logs tab will trigger logs refresh
        logsLoaded = false;
    };

    const _openSendNotificationModal = () => {
        isSendNotificationModalOpen = true;
    };

    const _closeSendNotificationModal = () => {
        isSendNotificationModalOpen = false;
    };

    const _openAfterSendNotificationModal = () =>
        (isNotificationFinishModalOpen = true);

    const _closeAfterSendNotificationModal = () =>
        (isNotificationFinishModalOpen = false);

    const cancelPatientNotification = async () => {
        isCancelUpdateRequestModalOpen = false;

        btnOptions[0].isLoading = true;

        await apiMethods.postMethod
            .cancelNotifyPatient(encounterId)
            .then((res) => {
                if (getBoolean(res) == "Yes") {
                    isCancelNotificationModalOpen = true;
                    reloadPatientDetails();
                } else
                    showError(
                        "Failed to send notification to patient, please refresh the page and try again and contact support if the issue persists.",
                    );
            });

        btnOptions[0].isLoading = false;
    };

    const _openConfirmChangeBadDebtorByMedicareModal = () =>
        (updatePatientBadDebtorByMedicareModalOpen = true);

    const _closeConfirmBadDebtorByMedicareModal = () =>
        (updatePatientBadDebtorByMedicareModalOpen = false);

    $: hasDefaultContact = checkPatientContacts(patientDetails);

    let defaultContact;

    const checkPatientContacts = (data) => {
        if (data && data.patientContacts && data.patientContacts.length) {
            defaultContact = data.patientContacts.find((c) => c.useAsContact);
            return !!defaultContact;
        } else {
            defaultContact = null;
            return false;
        }
    };

    const changeEncounterFromOpvCheck = async (insuranceId, membershipNo, membershipRefNo) => {
        //do something with the new ins details
        patientDetails.insuranceType = 0; //Private now
        patientDetails.insuranceId = insuranceId;
        patientDetails.membershipNo = membershipNo;
        patientDetails.membershipRefNo = membershipRefNo;
        patientDetails.membershipRefNo =
                    membershipRefNo
                        ? Number(membershipRefNo)
                        : null;

        await apiMethods.putMethod
            .updatePatient(patientDetails)
            .then(async (res) => {
                if (res.id) {
                    patientEncounter.patient = { ...res } //update encounter update patient property

                    patientEncounter = syncInsuranceDetailsOfLatestBillingData( //sync insurance details on billing data
                        patientEncounter,
                    );
                    
                    await apiMethods.putMethod
                    .updatePatientEncounter(patientEncounter, false, "Update encounter from OPV Check modal")
                    .then(async (res) => {
                        if (res.id) {
                            //trigger reload
                            await reloadPatientEncounter();

                            isCheckOpvOnDiffFundModalOpen = false; //close opv modal
                        } else showError(res.error);
                    })
                    .catch((err) => showException(err));
                } else showError(res.error);
            })
            .catch((err) => showException(err));

    }

    const getNotificationToPatientBtnOptions = () => {
        var btnOptions =  [
            {
                text: "Cancel",
                class: "btn btn-error",
                function: () => _closeSendNotificationModal(),
            },
            {
                text: "Confirm",
                function: () => sendNotificationToPatient(),
                isLoading: isSendingNotificationToPatient,
            }
        ];
        if(!isWithinBusinessHours(new Date())){
            btnOptions = [...btnOptions, {
                text: "Send now",
                function: () => sendNotificationToPatient(true),
                isLoading: isSendingNotificationToPatient,
            }]
        }

        return btnOptions;
    }
</script>

<CardLayout title="Patient Details" {btnOptions} {bottomLinks}>
    <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex flex-row gap-x-2">
                <p class="title">Full Name:</p>
                <p
                    class="content plink"
                    on:click|preventDefault={_redirectToPatient}
                >
                    {displayFullName}
                </p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Gender:</p>
                <p class="content">{getGenderType(patientDetails.sex)}</p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Date of Birth:</p>
                <p class="content">
                    {getFormatBirthDate(patientDetails.birthDate)}
                </p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Phone:</p>
                <p class="content">{getText(patientDetails.phone)}</p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Email:</p>
                {#if patientDetails.email}
                    <a
                        href="mailto:{patientDetails.email}"
                        target="_blank"
                        class="content break-all hover:text-[#8A3ED7] hover:underline hover:font-bold"
                    >
                        {getText(patientDetails.email)}
                    </a>
                {/if}
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">UR Number:</p>
                <p class="content">{getText(patientDetails.urNumber)}</p>
            </div>

            {#if hasDefaultContact}
                <div class="flex flex-row gap-x-2">
                    <p class="title">Contact Person:</p>
                    <p
                        on:click={() => scrollIntoView("contactsTable")}
                        class="content plink"
                    >
                        {defaultContact.name}
                    </p>
                </div>
            {/if}

            <div class="flex flex-row gap-x-2">
                <p class="title">Address:</p>
                <p class="content">{_getPatientAddress()}</p>
            </div>
        </div>

        <div class="divider lg:divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-2">
            {#if patientDetails.badDebtor || patientDetails.badDebtorByMedicare}
                <div class="cursor-default badge badge-error">
                    {patientDetails.badDebtorByMedicare
                        ? "Bad Debtor recognised by Medicare Number"
                        : "Bad Debtor"}
                </div>
            {/if}

            <PatientInsuranceDetails {patientDetails} {patientEncounter} />
        </div>

        <div class="divider lg:divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-4 h-full">
            {#if patientDetails.insuranceType == 20}
                <div class="flex flex-row gap-x-2">
                    <p class="title">DVA Verification Status:</p>
                    <p
                        class={`content ${
                            patientDetails.opvStatusVeteran == 1
                                ? "text-greenDefault"
                                : patientDetails.opvStatusVeteran == 2 ||
                                    patientDetails.opvStatusVeteran == 3
                                  ? "text-red-400"
                                  : ""
                        }`}
                    >
                        {#if !isCheckingOPV}
                            {getOpvStatusDVA(patientDetails.opvStatusVeteran)}
                        {/if}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Verification manually approved:</p>
                    <p class="content">
                        {getBoolean(patientDetails.opvManuallyApproved)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p
                        class="cursor-pointer underline"
                        on:click|preventDefault={runOpvCheck}
                    >
                        Run DVA Check
                    </p>
                    {#if isCheckingOPV}
                        <Loader />
                    {/if}
                </div>

                {#if isUserAdmin}
                    <div class="flex w-full">
                        <p class="title">Manually Approve OPV</p>
                        <input
                            type="checkbox"
                            class="toggle toggle-secondary"
                            disabled={isUpdatingEncounterOpvManuallyApprove}
                            bind:checked={patientEncounter.opvManuallyApproved}
                            on:click={updateEncounterOpvManuallyApprove}
                        />
                    </div>
                {/if}
            {:else}
                <div class="flex flex-row gap-x-2">
                    <p class="title">OPV Status - Medicare:</p>
                    <p
                        class={`content z-[0] hover:z-[1] ${
                            patientDetails.opvStatusMedicare == 1
                                ? "text-greenDefault"
                                : patientDetails.opvStatusMedicare == 2 ||
                                    patientDetails.opvStatusMedicare == 3
                                  ? "text-red-400"
                                  : ""
                        }`}
                    >
                        {#if !isCheckingOPV}
                            {getOpvStatusMedicare(
                                patientDetails.opvStatusMedicare,
                            )}
                        {/if}

                        {#if !isCheckingOPV && (patientDetails.opvStatusMedicare == 2 || patientDetails.opvStatusMedicare == 3)}
                            <CustomTooltip
                                contentClass="border-red-400"
                                hoverTriggerFunc={loadLogs}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    class="h-6 w-6 pb-1 shrink-0 stroke-current text-red-400"
                                    slot="tooltipTrigger"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    ></path>
                                </svg>

                                {#if isLoadingLogs}
                                    <div class="flex items-center gap-x-2">
                                        <Loader />
                                        <p>Loading latest log details...</p>
                                    </div>
                                {:else if latestEclipseLog && !isObjectEmpty(latestEclipseLog)}
                                    <div class="flex flex-col gap-y-1">
                                        <p>
                                            Code: {latestEclipseLog
                                                .medicareStatus.status.code}
                                        </p>
                                        <p>
                                            Suggestion: {latestEclipseLog
                                                .medicareStatus.status.text}
                                        </p>
                                    </div>
                                {:else}
                                    <p>No valid Medicare description</p>
                                {/if}
                            </CustomTooltip>
                        {/if}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">OPV Status - Health Fund:</p>
                    <p
                        class={`content z-[0] hover:z-[1] ${
                            patientDetails.opvStatusHealthFund == 1
                                ? "text-greenDefault"
                                : patientDetails.opvStatusHealthFund == 2 ||
                                    patientDetails.opvStatusHealthFund == 3
                                  ? "text-red-400"
                                  : ""
                        }`}
                    >
                        {#if !isCheckingOPV}
                            {getOpvStatusHealthFund(
                                patientDetails.opvStatusHealthFund,
                            )}
                        {/if}

                        {#if !isCheckingOPV && (patientDetails.opvStatusHealthFund == 2 || patientDetails.opvStatusHealthFund == 3)}
                            <CustomTooltip
                                contentClass="border-red-400"
                                hoverTriggerFunc={loadLogs}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    class="h-6 w-6 pb-1 shrink-0 stroke-current text-red-400"
                                    slot="tooltipTrigger"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    ></path>
                                </svg>

                                {#if isLoadingLogs}
                                    <div class="flex items-center gap-x-2">
                                        <Loader />
                                        <p>Loading latest log details...</p>
                                    </div>
                                {:else if latestEclipseLog && !isObjectEmpty(latestEclipseLog)}
                                    <div class="flex flex-col gap-y-1">
                                        <p>
                                            Code: {latestEclipseLog
                                                .medicareStatus.status.code}
                                        </p>
                                        <p>
                                            Suggestion: {latestEclipseLog
                                                .healthFundStatus.status.text}
                                        </p>
                                    </div>
                                {:else}
                                    <p>No valid Health Fund description</p>
                                {/if}
                            </CustomTooltip>
                        {/if}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Verification manually approved:</p>
                    <p class="content">
                        {getBoolean(patientDetails.opvManuallyApproved)}
                    </p>
                </div>

                {#if patientDetails.insuranceType == 0 || patientDetails.insuranceType == 11}
                    <div class="flex flex-row gap-x-2">
                        <p
                            class="cursor-pointer underline"
                            on:click|preventDefault={runOpvCheck}
                        >
                            Run OPV Check
                        </p>
                        {#if isCheckingOPV}
                            <Loader />
                        {/if}
                    </div>

                    {#if isUserAdmin}
                        <div class="flex w-full">
                            <p class="title">Manually Approve OPV</p>
                            <input
                                type="checkbox"
                                class="toggle toggle-secondary"
                                disabled={isUpdatingEncounterOpvManuallyApprove}
                                bind:checked={patientEncounter.opvManuallyApproved}
                                on:click={updateEncounterOpvManuallyApprove}
                            />
                        </div>
                    {/if}
                {/if}
            {/if}
            {#if patientDetails.medicareNo && patientDetails.medicareRefNo}
                <div class="flex flex-row gap-x-2">
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                    <p
                        class="cursor-pointer underline"
                        on:click|preventDefault={() => {
                            isCheckOpvOnDiffFundModalOpen = true;
                        }}
                    >
                        Check OPV on different fund
                    </p>
                </div>
            {/if}
        </div>
    </div>
</CardLayout>

{#if isCheckOpvOnDiffFundModalOpen}
    <OpvOnDiffFund
        onClose={() => isCheckOpvOnDiffFundModalOpen = false }
        onConfirmChangeFund={(insuranceId, membershipNo, membershipRefNo) => {
            changeEncounterFromOpvCheck(insuranceId, membershipNo, membershipRefNo)
        }}
        isCheckOpvOnDiffFundModalOpen={isCheckOpvOnDiffFundModalOpen}
        patientDetails={patientDetails}
        patientEncounter={patientEncounter}
    >
    </OpvOnDiffFund>
{/if}

<NotificationModal
    title="Verification Failed"
    isModalOpen={isSuggestionModalOpen}
    closeModal={closeSuggestionModal}
    closeModalFunction={closeSuggestionModal}
    cancelText="Cancel"
    confirmAction={applySuggestion}
    submitText={isApplyingSuggestion ? "Applying" : "Apply Suggestion"}
    isConfirming={isApplyingSuggestion}
>
    <div class="flex flex-col gap-y-4">
        <p class="leading-6">Suggestions:</p>
        <!-- <p class="leading-6 text-error">{error}</p> -->
        <div class="flex flex-col gap-y-2 px-6">
            {#each Object.entries(suggestedPatientInfo) as [key, value]}
                {#if value}
                    <p>
                        Change {splitCamelCase(key)} to:
                        <span class="text-error">{value}</span>
                    </p>
                {/if}
            {/each}
        </div>
    </div>
</NotificationModal>

<NotificationModal
    isModalOpen={isSendNotificationModalOpen}
    title="Notify patient to update details"
    closeModal={_closeSendNotificationModal}
    confirmAction={sendNotificationToPatient}
    showCancelBtn={false}
    showConfirmBtn={false}
    btnOptions={getNotificationToPatientBtnOptions()}
    closeModalFunction={_closeSendNotificationModal}
>
    <p class="leading-6">
        Once you have asked a patient to update their details, you will not be
        permitted to quote the patient or submit an invoice while you wait for
        them to respond or until 24 hours has elapsed, although you can cancel
        the request once sent.
    </p>
    <p class="leading-6">Are you sure you want to do this?</p>
    {#if !isWithinBusinessHours(new Date())}
        <br/>
        <b>You are requesting this outside business hours, the SMS notification will be sent during business hours.</b>
    {/if}
</NotificationModal>

<NotificationModal
    isModalOpen={isNotificationFinishModalOpen}
    closeModal={_closeAfterSendNotificationModal}
    showConfirmBtn={false}
    closeModalFunction={_closeAfterSendNotificationModal}
>
    Successfully sent notification to patient.
</NotificationModal>

<NotificationModal
    isModalOpen={isCancelUpdateRequestModalOpen}
    title="Cancel Patient Notification"
    closeModal={() => (isCancelUpdateRequestModalOpen = false)}
    confirmAction={cancelPatientNotification}
    cancelText="NO"
    submitText="Yes"
    closeModalFunction={() => (isCancelUpdateRequestModalOpen = false)}
>
    Would you like to cancel the request for patient to update details?
</NotificationModal>

<NotificationModal
    isModalOpen={isCancelNotificationModalOpen}
    closeModal={() => (isCancelNotificationModalOpen = false)}
    showConfirmBtn={false}
    closeModalFunction={() => (isCancelNotificationModalOpen = false)}
>
    Successfully cancelled patient update info notification.
</NotificationModal>

<UnsetPatientBadDebtorByMedicareModal
    bind:isModalOpen={updatePatientBadDebtorByMedicareModalOpen}
    isConfirming={isUpdatingPatientBadDebtorByMedicare}
    closeModal={_closeConfirmBadDebtorByMedicareModal}
    confirmAction={updatePatientBadDebtorByMedicare}
/>

<NotificationModal
    isModalOpen={isOpvResultModalOpen}
    title={opvVerificationSuccess
        ? "Verification Complete"
        : opvResponseWithErrorMsg
          ? "Verification Failed"
          : "Verification Error"}
    closeModal={() => {
        isOpvResultModalOpen = false;
        opvVerificationSuccess = false;
        opvResponseWithErrorMsg = false;
        opvResultMsg = "";
    }}
    closeModalFunction={() => {
        isOpvResultModalOpen = false;
        opvVerificationSuccess = false;
        opvResponseWithErrorMsg = false;
        opvResultMsg = "";
    }}
    showConfirmBtn={false}
    cancelText="Close"
>
    {#if opvVerificationSuccess}
        <p class="leading-6 p-4 text-secondary">
            Patient verified successfully.
        </p>
    {:else}
        {#if !opvResponseWithErrorMsg}
            <p class="leading-6 p-4 text-error">Failed to verify patient.</p>
        {/if}
        <p class="leading-6 p-4 text-error">
            {@html opvResultMsg}
        </p>
    {/if}
</NotificationModal>

<style>
    .title {
        width: 200px;
    }

    .content {
        width: calc(100% - 200px);
    }
</style>
